<div class="dl-normbalk__inner">
    @for (regel of regels(); track regel.type) {
        <span class="dl-normbalk__element">
            <span [class]="'dl-normbalk__icoon dl-normbalk__icoon--' + regel.type"></span>
            @if (onbekend()) {
                <span class="dl-normbalk__telling">–</span>
            } @else {
                <span [class]="'dl-normbalk__telling ' + kleurVoor(regel.geteld, regel.verwacht)">{{ regel.geteld }}<span class="dl-normbalk__totaal">/{{ regel.verwacht }}</span>@if (toonFouten()) {<span>/<span [class.dl-normbalk__fouten]="!!regel.fouten">{{ regel.fouten || 0 }}</span></span>}</span>
            }
        </span>
    }
    @if (namen(); as naamtelling) {
        <span class="dl-normbalk__element">
            <span class="dl-normbalk__icoon dl-normbalk__icoon--namen">#</span>
            @if (onbekend()) {
                <span class="dl-normbalk__telling">–</span>
            } @else {
                <span [class]="'dl-normbalk__telling ' + kleurVoor(naamtelling.aantal, naamtelling.norm)">{{ naamtelling.aantal || 0 }}<span class="dl-normbalk__totaal">/{{ naamtelling.norm || 0 }}</span></span>
            }
        </span>
    }
</div>
